// NPM imports
import Modal from "react-responsive-modal";
import React, { Component, Fragment } from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { connect } from "react-redux";
// import { Tooltip } from "../../revvComponents";

// Components Imports
import AgGridPriceMatrix from "../AgGridPriceMatrix";
import PriceControlForBundle from "../AgGridPriceForBundle";

// Actions Imports
import { DealTableActions } from "../../actions";

// Internal Imports
import { COMMON, GRID } from "../../constants";

// Destructuring
const { CURRENCY_SYMBOL } = COMMON;
const { PRICING_METHODS } = GRID;
const { onCellValueChange } = DealTableActions;

class PriceMatrixRenderer extends Component {
  _togglePopUp = () => {
    this.props.togglePopUp("pricingPopUp", false);
  };

  _onSave = matrixData => {
    const { columnData, data, dealTableId, rowData, rowIndex } = this.props;
    const units = JSON.parse(matrixData.units);
    const updatedRow = {
      ...data,
      rowMeta: {
        ...data.rowMeta,
        pricingData: {
          ...data.rowMeta.pricingData,
          price: matrixData.price,
          qty: units,
        },
      },
    };
    this.props.onCellValueChange(
      columnData,
      updatedRow,
      rowIndex,
      rowData,
      dealTableId,
    );
    this._togglePopUp();
  };

  _onBundleEffortsUpdate = updatedPrice => {
    const { columnData, data, dealTableId, rowData, rowIndex } = this.props;
    // Handle float value inside bundle arrayOfObj
    updatedPrice.bundles.forEach(item => {
      item.months = parseFloat(item.months);
    });
    const updatedRow = {
      ...data,
      rowMeta: {
        ...data.rowMeta,
        pricingData: {
          ...data.rowMeta.pricingData,
          bundles: updatedPrice.bundles,
          value: updatedPrice.value,
        },
      },
    };
    this.props.onCellValueChange(
      columnData,
      updatedRow,
      rowIndex,
      rowData,
      dealTableId,
    );
    this._togglePopUp();
  };

  render() {
    const { currency, fieldMapIndex, isLocked, data, value } = this.props;
    if (
      data.rowMeta.pricingData &&
      data.rowMeta.pricingData.type === PRICING_METHODS.BUNDLE_PRICING &&
      data.rowMeta.pricingData.isAdhoc
    ) {
      return (
        <Fragment>
          {/* <div
            onClick={() => this._togglePopUp(true)}
            onKeyPress={() => this._togglePopUp(true)}
            role="button"
            tabIndex="0">
            {value}
            <Tooltip
              placement="top"
              overlay="This is an ad-hoc SKU. Click here to enter effort for resources">
              <span className="dealtablefeild-edit">
                <FontAwesomeIcon icon={["far", "tilde"]} />
              </span>
            </Tooltip>
          </div>{" "}
          */}
          <Modal
            open
            onClose={this._togglePopUp}
            closeOnOverlayClick={false}
            center>
            <PriceControlForBundle
              currencySymbol={CURRENCY_SYMBOL[currency]}
              data={data.rowMeta.pricingData}
              isLocked={isLocked}
              onSave={this._onBundleEffortsUpdate}
              productName={data.rowData[fieldMapIndex.product_name].cellData}
            />
          </Modal>
        </Fragment>
      );
    }
    if (
      data.rowMeta.pricingData &&
      !data.rowMeta.pricingData.value &&
      data.rowMeta.pricingData.type !== PRICING_METHODS.NON_LINEAR &&
      data.rowMeta.pricingData.type !== PRICING_METHODS.DIY_PRICING
    ) {
      return (
        <Fragment>
          {/* <div
            onClick={() => this._togglePopUp(true)}
            onKeyPress={() => this._togglePopUp(true)}
            role="button"
            tabIndex="0">
            {value}
            <Tooltip
              placement="top"
              overlay="Quantity is a Range. Please click to edit this">
              <span className="dealtablefeild-edit">
                <FontAwesomeIcon icon={["far", "tilde"]} />
              </span>
            </Tooltip>
          </div>
          */}
          <Modal
            open
            onClose={this._togglePopUp}
            closeOnOverlayClick={false}
            center>
            <AgGridPriceMatrix
              currencySymbol={CURRENCY_SYMBOL[currency]}
              data={data.rowMeta.pricingData}
              isLocked={isLocked}
              minQty={data.rowData[fieldMapIndex.min_quantity].cellData}
              onSave={this._onSave}
              productName={data.rowData[fieldMapIndex.product_name].cellData}
              qtyUom={data.rowData[fieldMapIndex.quantity_uom].cellData}
            />
          </Modal>
        </Fragment>
      );
    }
    return <div>{value}</div>;
  }
}

const mapStateToProps = state => {
  // ::QUOTATION STORE
  const { dealTableId } = state.QuotationStore;

  // ::DEALTABLE STORE
  const {
    rowData: { [dealTableId]: rowData = [] } = {},
    priceBook: { [dealTableId]: priceBook = {} } = {},
    metaData: { fieldMapIndex },
  } = state.DealTableStore;

  // ::DOCUMENT STORE
  const {
    document: { isLocked },
  } = state.DocumentStore;

  // ::ASSIGN REDUX KEYS TO RESPECTIVE DECLARED PROP VALUES
  const currency = (priceBook && priceBook.currency) || "USD";

  return {
    currency,
    dealTableId,
    fieldMapIndex,
    isLocked,
    rowData,
  };
};

const mapDispatchToProps = {
  onCellValueChange,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PriceMatrixRenderer);
